import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RedirectCommand } from '@angular/router';
import { Observable, of } from 'rxjs';

import { DEFAULT_LANGUAGE } from '~constants/translations';
import { TranslationService } from '~services/translation.service';

@Injectable({
  providedIn: 'root',
})
export class LangGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly translationService = inject(TranslationService);

  canActivate(route: ActivatedRouteSnapshot): Observable<RedirectCommand> | boolean {
    const lang = route.paramMap.get('lang') || DEFAULT_LANGUAGE;
    const isLangValid = this.translationService.isLanguageValid(lang);

    if (!isLangValid) {
      console.warn(`Unsupported language: ${lang}. Falling back to 'en'.`);

      const segments = window.location.pathname.split('/').filter(Boolean);

      segments[0] = DEFAULT_LANGUAGE;

      const redirectPath = this.router.parseUrl(`${segments.join('/')}${window.location.search}`);

      return of(new RedirectCommand(redirectPath));
    }

    return true;
  }
}
